module.exports = __webpack_public_path__ + "media/application/images/icons/search-a35413e89c0101e4e80a616284271be8.svg";